/* eslint no-eval: 0 */

import ThumbDownAltIcon from '@material-ui/icons/ThumbDownAlt';
import ThumbUpAltIcon from '@material-ui/icons/ThumbUpAlt';
import _ from 'lodash';
import React, { cloneElement, Fragment, useEffect, useState } from 'react';
//style={{ color: 'purple' }}
import { Datagrid, FunctionField, List, SimpleList,sanitizeListRestProps, ShowButton, TextField, TopToolbar, useListContext, useNotify } from 'react-admin';
import BulkButtonOnSelected from '../communs/BulkButtonOnSelected';
import FormDialogPayement from '../dialog/FormDialogPayement.js';
import FiltreAllOrders from '../filtres/FiltreAllOrders';
//import ExportAgExp from './ExportAgExp';
import PostPagination from '../paginations/pagination';
import { json, PhoneDestField, PhoneExpField } from '../references.js';
import rowStyle from '../styles/rowStyle';
import moment from 'moment';
import { useMediaQuery } from '@material-ui/core';
import CustomGrid from './CustomGrid'
const style={marginLeft:15,marginTop:5}
const postRowStyle = (record, index) => ({
    backgroundColor: index%2==0 ? '#edd5f5' :'white'
});

 const  ListAllOrders=(props)=>{

    const {resource,permissions}=props;
    const [listCamps, setListCamps] = useState([]);
    const notify = useNotify();
    const currentDate = moment().format().slice(0,10);
    const isSmall = useMediaQuery(theme => theme.breakpoints.down('sm'));

    useEffect(() => {
        
        fetch(process.env.REACT_APP_URL+'/camp/getCampagneForFilters?resource='+resource, 
        { method: 'GET',
        headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json;charset=UTF-8',
                "Authorization": "Bearer "+ localStorage.getItem('token')
        }
    }
        ).then(json)
        .then((data) => {
            if(data && data.status>310 && data.error){
                notify(data.error+' : '+data.message,'error');
            } else {
                setListCamps(data);
            }
        }).catch((e) => {
            notify("Erreur lors de la récuperation des campagnes pour le filtre !", 'warning')
        });
       
    }, []);

 return(
        <List {...props}  
                bulkActionButtons={<PostBulkActionButtons  {...props}/>}
                actions={<ListActions permissions={permissions} {...props} />}
                filters={<FiltreAllOrders {...props} listCamps={listCamps}/>} 
                pagination={<PostPagination {...props}/>}
                sort={{ field: 'id', order: 'DESC' }}
                title={'Tous - '+localStorage.getItem('fullname')}
                empty={false}
                filterDefaultValues={{"start_date":currentDate,"end_date":currentDate}} 
            >
             {isSmall ? (
                
                
                <CustomGrid />
            ) : (
            <Datagrid rowStyle={rowStyle} optimized >
                <TextField source="camp_code" label="Code Camp" style={{ color: 'purple'  }} />
                <TextField source="camp_type" label="Type Camp"  />
                <TextField source="code" label="Code" sortBy="code"/>
                <TextField source="agent_fullname" label="Agent" sortBy="agent_fullname"/>
                <PhoneExpField source="tel_exp" label="Expéditeur" sortBy="tel_exp"/>
                <PhoneDestField source="tel_dest" label="Destinateur"  sortBy="tel_dest"/>
                <TextField source="status" label="Status" /> 
                <TextField source="total_encaisse" label="Encaissé(€)" sortBy="total_encaisse"/> 
                <TextField source="reste_a_payer" label="Reste a payé(€)" sortBy="reste_a_payer"/>
                <TextField source="total_general" label="Total TTC(€)" sortBy="total_general"/> 
                <TextField source="created_date" label="Date" />
                <ShowButton />    
                <FunctionField render={record =>(record.reste_a_payer) ?  <FormDialogPayement from="list" data={record} /> :  null } />
            </Datagrid>
            )}
        </List>
       ) ;
    };

export default ListAllOrders;

var mergeData=[];
const PostBulkActionButtons = props => {
    const { data, selectedIds } = useListContext();
    mergeData=_.merge(mergeData,data);    
    const res=calcul_selectedValues(selectedIds,mergeData);
    const { orderStatus } =props.filterValues;
    return <Fragment>       
        <p style={style}>Total encaissé : {res.total_encaisse}</p>
        <p style={style}>Reste à payer  : {res.reste_a_payer}</p>
        <p style={style}>Total TTC   : {res.total_general}</p>
        
        <>
            { orderStatus==='ATTENTE' ?
                <BulkButtonOnSelected 
                    src='aerien/updateStatus'
                    newSatus='APPV'
                    buttonLabel='Valider'
                    confirmeTitle='Validation des factures selectionnées'
                    confirmeMessage='Etes vous sûre de vouloir valider les factures selectionnées  ?'
                    buttonIcon={<ThumbUpAltIcon />}
                    style={{marginLeft:15,color:'green'}}
                    {...props}
                />:
                orderStatus==='APPV' ?
                <BulkButtonOnSelected 
                    src='aerien/updateStatus'
                    newSatus='ATTENTE'
                    buttonLabel='Dévalider'
                    confirmeTitle='Dévalidation des factures selectionnées'
                    confirmeMessage='Etes vous sûre de vouloir dévalider les factures selectionnées ?'
                    buttonIcon={<ThumbDownAltIcon />}
                    style={{marginLeft:5,color:'red'}}
                    {...props}
                />:
                orderStatus==='ANNULER' ? 
                <BulkButtonOnSelected 
                    src='aerien/updateStatus'
                    newSatus='ATTENTE'
                    buttonLabel='Restaurer'
                    confirmeTitle='Validation des factures selectionnées'
                    confirmeMessage='Etes vous sûre de vouloir valider les factures selectionnées  ?'
                    buttonIcon={<ThumbUpAltIcon />}
                    style={{marginLeft:15,color:'green'}}
                    {...props}
                />:
                null
            }
            </>
    </Fragment>
};

const calcul_selectedValues=(selectedIds,myData)=>{

    if(selectedIds && selectedIds.length===0) return  {reste_a_payer:0,total_encaisse:0,total_general:0}
    const data=myData ? Object.values(myData):[];
    const records = data ? data.filter(record => selectedIds.includes(record.id)):[];

    var reste_a_payer=records.map(record=>eval(record.reste_a_payer));
    var total_encaisse=records.map(record=>eval(record.total_encaisse));
    var total_general=records.map(record=>eval(record.total_general));

    reste_a_payer = _.reduce(reste_a_payer,function(memo, val) {
          return memo+val;
        });

    total_encaisse = _.reduce(total_encaisse,function(memo, val) {
          return memo+val;
        });
    
    total_general = _.reduce(total_general,function(memo, val) {
             return memo+val;
        });
    return {reste_a_payer:reste_a_payer+' €',total_encaisse:total_encaisse+' €',total_general:total_general+' €'}
}

const ListActions = (props) => {
    const {
        className,
        exporter,
        filters,
        maxResults,
        permissions,
        ...rest
    } = props;
    const {
        resource,
        displayedFilters,
        filterValues,
        showFilter
    } = useListContext();
    return (
        <TopToolbar className={className} {...sanitizeListRestProps(rest)}>
            {filters && cloneElement(filters, {
                resource,
                showFilter,
                displayedFilters,
                filterValues,
                context: 'button'
            })}           
        </TopToolbar>
    );
};

/*
<SimpleList
                    primaryText={record =>'Code:'+ record.code}
                    secondaryText={record => `${'Exp:'+record.client_exp+' '+record.tel_exp} ${'Dest:'+record.client_dest+' '+record.tel_dest}`}
                    rowStyle={postRowStyle}

                    // `${record.camp_type+' '+record.camp_code}`
                    //secondaryText={record => record.camp_type}
                    tertiaryText={record =>'Date:'+ new Date(record.created_date).toLocaleDateString()+
                    ' Encaissé:'+record.total_encaisse+' Reste à payé :'+record.reste_a_payer}
                    linkType={record => record.canEdit ? "edit" : "show"}   
                />*/